import React, { useState, useCallback } from 'react';

import ControllableModal from './Controllable';

type ModalProps = {
  className?: string;
  contentClassName?: string;
  children: React.ReactNode;
  isdefaultShow?: boolean;
  modalTopImageUrl?: string;
  modalName?: string;
  handleIgnoreChanges: () => void;
  isScrollVisible?: boolean;
  parentModalStateChangeHandler: Function;
};

const Modal = ({
  className,
  contentClassName,
  children,
  isdefaultShow,
  parentModalStateChangeHandler,
  modalTopImageUrl,
  modalName,
  handleIgnoreChanges,
  isScrollVisible,
}: ModalProps) => {
  const [isShow, setIsShow] = useState(isdefaultShow ?? true);

  const onClose = useCallback(() => {
    handleIgnoreChanges();
    setIsShow(false);
    parentModalStateChangeHandler(false);
  }, [handleIgnoreChanges, parentModalStateChangeHandler]);

  if (!isShow) {
    return null;
  }

  return (
    <ControllableModal
      className={className}
      contentClassName={contentClassName}
      modalTopImageUrl={modalTopImageUrl}
      modalName={modalName}
      isScrollVisible={isScrollVisible}
      isShow={isShow}
      onClose={onClose}
    >
      {children}
    </ControllableModal>
  );
};

export default Modal;
